// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CounterTitle-wrapper_1f809236","primary":"CounterTitle-primary_53b6c0f5","secondary":"CounterTitle-secondary_ead59791","button":"CounterTitle-button_3872ea0c"};